import React, { useEffect, useState } from "react";
import { requestDeleteSubscription } from "../../../../../redux/actions/company";
import { useDispatch, useSelector } from "react-redux";
import { changeCompanyModal } from "../../../../../redux/actions/company";
import { TransparentButton, SolidButton } from "../../../../library/button";
import { Popup } from "../../../../library/popup";
import "./style.scss";
import { Label } from "../../../../library/label";
import { Select } from "../../../../library/select";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";

const Index = () => {
  const dispatch = useDispatch();

  const [selectedChannel, setSelectedChannel] = useState(undefined);

  const modalState = useSelector(
    (state) => state.company.showModals.cancelSubscription
  );
  const subscription = useSelector((state) => state.company.activeSubscription);
  const companyId = useSelector(
    (state) =>
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const loading = useSelector(
    (state) => state.company.deleteSubscription.loading
  );

  useEffect(() => {
    if (subscription.channels) {
      setSelectedChannel(subscription.channels[0].id);
    }
  }, []);

  const handleClose = () => {
    dispatch(changeCompanyModal({ cancelSubscription: false }));
  };

  const clickCancelSubscription = () => {
    if (subscription.type === "main") {
      dispatch(
        requestDeleteSubscription({
          subscriptionId: subscription.id,
          type: subscription.type,
          companyId: companyId,
          channelRef: selectedChannel,
        })
      );
    } else {
      if (selectedChannel) {
        dispatch(
          requestDeleteSubscription({
            subscriptionId: subscription.id,
            type: subscription.type,
            companyId: companyId,
            channelRef: selectedChannel,
          })
        );
      }
    }
  };

  const selectChannel = (id) => {
    if (subscription.channels) {
      const details = subscription.channels.filter((s) => s.id === id);
      if (details && details.length > 0) {
        setSelectedChannel(details[0].id);
      } else {
        sendErrorNotification("Kunne ikke velge kanal.");
      }
    }
  };

  const renderChannels = () => {
    const allChannels = [];
    if (subscription.channels) {
      subscription.channels.map((channel, index, length) => {
        allChannels.push({
          id: channel.id,
          title: channel.username,
          value: channel.id,
          selected: selectedChannel === channel.id,
        });
      });
    }
    return allChannels;
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Vil du avslutte abonnementet?"
      buttons={[
        <TransparentButton
          title="Avbryt"
          type="button"
          data-dismiss="modal"
          onClick={() => handleClose()}
        />,
        <SolidButton
          color="red"
          title={!loading ? "Ja, avslutt abonnement" : "Avslutter.."}
          icon={
            loading ? <i className="fas fa-circle-notch fa-spin"></i> : null
          }
          onClick={() => clickCancelSubscription()}
          type="button"
        />,
      ]}
    >
      <div className="">
        <Label version="2">
          Det valgte abonnementet vil bli avsluttet umiddelbart, men dersom du
          har noe utestående vil dette bli fakturert automatisk før terminering.
        </Label>
        {subscription.type !== "main" && (
          <>
            <Label weight="bold" version="1">
              Velg kanal
            </Label>
            <Select
              disabled={subscription.channels.length === 1}
              onChange={(e) => selectChannel(e.target.value)}
              items={renderChannels()}
            />
          </>
        )}
      </div>
    </Popup>
  );
};

export default Index;
